"use strict";
jQuery.fn.attachedToDOM = function(){
    var r = false;
    if (this[0]){
        r = !!$.contains(this[0].ownerDocument, this[0]);
    }
    return r;
};